<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      fill-rule="evenodd"
      d="M8 2.8a10 10 0 1 1-5.2 13 1 1 0 1 1 1.7-.7 8.1 8.1 0 1 0 .7-7.5h2.1a1 1 0 1 1 0 1.9H2V4.2a1 1 0 0 1 1.9 0v2A10 10 0 0 1 8 2.8"
      clip-rule="evenodd"
    />
    <path
      d="M12.2 17.4V6.5h.7v11zm2.2-7.5q0-.6-.6-1-.5-.3-1.3-.3-.5 0-.9.2-.3 0-.6.4l-.2.7.1.5.4.4.5.3.6.1.8.3.9.2.8.5q.5.3.6.7.3.4.2 1 0 .8-.3 1.3l-1.1 1q-.7.3-1.8.3-1 0-1.7-.3-.7-.4-1.1-1T9.3 14h1.3q0 .5.3.8l.7.5 1 .1q.5 0 .9-.2.4-.1.7-.5.3-.3.2-.7 0-.5-.2-.6l-.6-.5-.8-.2-1-.3a4 4 0 0 1-1.7-.9q-.6-.5-.6-1.4t.4-1.3q.4-.6 1.1-1l1.6-.2q.8 0 1.5.3.8.3 1.1.8t.4 1.3z"
    />
  </svg>
</template>
